"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LogOutIcon = function LogOutIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 4C4 3.44772 4.44772 3 5 3H10C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H6V15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H5C4.44772 17 4 16.5523 4 16V4Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3848 6.25611C13.2537 6.15246 13.0608 6.24587 13.0608 6.41302V9.00003H9C8.44772 9.00003 8 9.44775 8 10C8 10.5523 8.44772 11 9 11H13.0608V13.587C13.0608 13.7542 13.2537 13.8476 13.3848 13.7439L17.9231 10.1569C18.0244 10.0768 18.0244 9.92318 17.9231 9.84311L13.3848 6.25611Z",
    fill: color
  }));
};

var _default = LogOutIcon;
exports.default = _default;